import { Observable } from 'rxjs';
import { PurchasePersistenceModel } from '../models/PurchasePersistence.model';

export abstract class PurchasePersistenceRepository {
    abstract savePurchase(
        purchase: PurchasePersistenceModel,
    ): Observable<PurchasePersistenceModel>;
    abstract getPurchase(): Observable<PurchasePersistenceModel>;
    abstract deletePurchase(): Observable<void>;
}
